// カテゴリ候補モーダルの制御。
// 1枚目画像の判定結果が confidence=medium の時、category_classify_handler から openCategoryCandidatesModal() で開かれる。
//
// UI フロー: ユーザーが候補ピルを1つ選択 → 「選択する」押下で確定、または「選択せず次へ」/ Esc / × でキャンセル。
// photo_example_modal.js と同様に body スクロールロック / a11y focus 制御を行う。

let savedScrollY = 0;

function lockBodyScroll() {
  savedScrollY = window.scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${savedScrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
}

function unlockBodyScroll() {
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  window.scrollTo(0, savedScrollY);
}

// 候補ピルを描画する。選択状態は「クラス .is-selected + aria-pressed=true」で表現。
// 返り値は currentSelection を外部から読むための getter（確定時に使用）。
function renderPills(listEl, candidates, onSelectionChange) {
  listEl.innerHTML = '';
  let selected = null;

  candidates.forEach((candidate) => {
    const li = document.createElement('li');
    li.className = 'category-candidates-item';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'category-candidates-pill';
    btn.textContent = candidate.category_name;
    // radiogroup 内のラジオ相当。単一選択を role=radio + aria-checked で表現する
    btn.setAttribute('role', 'radio');
    btn.setAttribute('aria-checked', 'false');

    btn.addEventListener('click', () => {
      // 既に他のピルが選択されていれば解除してから新しいピルを選択
      listEl.querySelectorAll('.category-candidates-pill').forEach((el) => {
        el.classList.remove('is-selected');
        el.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-checked', 'true');
      selected = candidate;
      onSelectionChange(selected);
    });

    li.appendChild(btn);
    listEl.appendChild(li);
  });

  return () => selected;
}

// 現行セッションの close を指す module-level ref。再入時に前セッションを先に閉じるため。
// 前セッションが閉じられないまま新規 open が走ると listener が重複登録され、
// lockBodyScroll の savedScrollY が上書きされて unlock 時にスクロールが飛ぶ。
let closeCurrentSession = null;

// @param candidates [{category_id, parent_category_id, category_name}[]] score降順
// @param options.imageUrl [string] サムネイル表示用の画像URL（Uppyのpreview data URL）
// @param options.onSelect (candidate | null) => void
//   - candidate: 「選択する」で確定された候補
//   - null: 「選択せず次へ」/ Esc / × / オーバーレイクリック（キャンセル相当）
export function openCategoryCandidatesModal(candidates, { onSelect, imageUrl } = {}) {
  const modal = document.getElementById('category-candidates-modal');
  if (!modal || candidates.length === 0) return;

  // 前セッションを先に閉じてから新規セットアップ。前セッションの onSelect は null(キャンセル相当) で発火。
  closeCurrentSession?.();

  const listEl = modal.querySelector('.category-candidates-list');
  const closeBtn = modal.querySelector('.category-candidates-modal-close');
  const confirmBtn = modal.querySelector('.category-candidates-confirm');
  const skipBtn = modal.querySelector('.category-candidates-skip');
  const thumbnailImg = modal.querySelector('.category-candidates-thumbnail img');
  const lastFocusedElement = document.activeElement;

  if (thumbnailImg) thumbnailImg.src = imageUrl || '';

  // 閉じ方は「確定 / キャンセル」の2経路。どちらも後処理（リスナー解除/スクロール解放/focus戻し）を通したいので 1 箇所に集約する。
  let resolved = false;
  const closeModal = (candidate) => {
    if (resolved) return;
    resolved = true;
    closeCurrentSession = null;

    modal.classList.add('hidden');
    unlockBodyScroll();

    confirmBtn?.removeEventListener('click', onConfirm);
    skipBtn?.removeEventListener('click', onCancel);
    closeBtn?.removeEventListener('click', onCancel);
    modal.removeEventListener('click', onOverlayClick);
    document.removeEventListener('keydown', onKeydown);

    onSelect?.(candidate);
    lastFocusedElement?.focus?.();
  };
  closeCurrentSession = () => closeModal(null);

  const onCancel = () => closeModal(null);
  const onOverlayClick = (e) => {
    if (e.target === modal) closeModal(null);
  };
  const onKeydown = (e) => {
    if (e.key === 'Escape') closeModal(null);
  };
  const getSelected = renderPills(listEl, candidates, (candidate) => {
    // ピルが選択されたら「選択する」を活性化。disabled 属性は primary の色分岐 CSS のトリガーでもある
    if (confirmBtn) confirmBtn.disabled = candidate == null;
  });
  const onConfirm = () => {
    const selected = getSelected();
    if (!selected) return;
    closeModal(selected);
  };

  // 未選択状態で開始
  if (confirmBtn) confirmBtn.disabled = true;

  confirmBtn?.addEventListener('click', onConfirm);
  skipBtn?.addEventListener('click', onCancel);
  closeBtn?.addEventListener('click', onCancel);
  modal.addEventListener('click', onOverlayClick);
  document.addEventListener('keydown', onKeydown);

  modal.classList.remove('hidden');
  lockBodyScroll();
  closeBtn?.focus();
}
